import {
	GetRefundProtocolStatus,
	GetRefundProtocolStatusParams,
} from 'domain/usecases/private/refund/consult-refunds/get-refund-protocol-status';
import {consultRefundProtocolStatus} from './consultRefundProtocolStatus';
import {RefundStatusDrawerData} from './types';

export function getRefundProtocolStatus(refundProtocolStatus: GetRefundProtocolStatus) {
	return {
		perform: async ({
			protocolCode,
			signal,
		}: GetRefundProtocolStatusParams): Promise<RefundStatusDrawerData> => {
			const result = await refundProtocolStatus.get({protocolCode, signal});
			return consultRefundProtocolStatus(result).drawerData();
		},
	};
}
